// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vip-inst-subnav {
  background: #0b0e11;
  border-bottom: 1px solid rgba(243, 186, 47, 0.18);
  position: relative;
  z-index: 30;
}

body.light_theme .vip-inst-subnav {
  background: #111318;
}

.vip-inst-subnav__inner {
  width: 1480px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 56px;
  overflow: visible;
}

.vip-inst-subnav__brand {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #fff;
  text-decoration: none;
  margin-right: 18px;
  white-space: nowrap;
}

.vip-inst-subnav__brand span {
  color: #f3ba2f;
}

.vip-inst-subnav__item {
  position: relative;
}

.vip-inst-subnav__link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  padding: 16px 14px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}

.vip-inst-subnav__link:hover,
.vip-inst-subnav__link.is-active {
  color: #f3ba2f;
  text-decoration: none;
}

.vip-inst-subnav__link.is-active {
  border-bottom-color: #f3ba2f;
}

.vip-inst-subnav__caret {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid currentColor;
  opacity: 0.7;
}

.vip-inst-subnav__menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 360px;
  margin: 0;
  padding: 10px 0;
  list-style: none;
  background: #1e2329;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);
  z-index: 40;
}

.vip-inst-subnav__menu-link {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  color: #eaecef;
  text-decoration: none;
}

.vip-inst-subnav__menu-link:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  text-decoration: none;
}

.vip-inst-subnav__menu-link img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex-shrink: 0;
  margin-top: 2px;
}

.vip-inst-subnav__menu-title,
.vip-inst-subnav__menu-desc {
  display: block;
}

.vip-inst-subnav__menu-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
}

.vip-inst-subnav__menu-desc {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.55);
  white-space: normal;
  max-width: 280px;
}

.vip-inst-subnav__badge,
.nav-title-badge--new,
.navigation .navbar-nav .dropdown-menu .dropdown-item .dropdown-item-content sub.nav-title-badge--new,
.navbar-expand-lg .navbar-nav .dropdown-menu .dropdown-item .dropdown-item-content sub.nav-title-badge--new {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  background: #fcd535;
  color: #181a20;
  border-radius: 10px;
  padding: 3px 6px;
  position: relative;
  bottom: 6px;
}

.dropdown-item-content .nav-title-badge--new {
  margin-left: 6px;
  vertical-align: middle;
  bottom: 0;
}

.navigation .navbar-nav .dropdown-menu.dropdown-menu--institutional,
.navbar-expand-lg .navbar-nav .dropdown-menu.dropdown-menu--institutional {
  min-width: 440px;
  overflow: visible;
}

.navigation .navbar-nav .dropdown-menu.dropdown-menu--institutional .dropdown-item .dropdown-item-desc,
.navbar-expand-lg .navbar-nav .dropdown-menu.dropdown-menu--institutional .dropdown-item .dropdown-item-desc {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}

.dropdown-menu--institutional .inst-menu-arrow {
  margin-left: 8px;
  color: #d1aa67;
}

.dropdown-menu--institutional .inst-menu-has-children {
  position: relative;
}

.dropdown-menu--institutional .inst-menu-flyout {
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 280px;
  margin: 0;
  padding: 8px 0;
  list-style: none;
  background: #1e2329;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);
  z-index: 50;
}

.dropdown-menu--institutional .inst-menu-has-children:hover .inst-menu-flyout,
.dropdown-menu--institutional .inst-menu-has-children:focus-within .inst-menu-flyout {
  display: block;
}

body.light_theme .dropdown-menu--institutional .inst-menu-flyout {
  background: #ffffff;
  border-color: #e2e8f0;
}

.vip-otc-nav--menu {
  position: relative;
}

.vip-otc-nav--menu .vip-inst-subnav__menu {
  display: none;
}

.vip-otc-nav--menu:hover .vip-inst-subnav__menu,
.vip-otc-nav--menu:focus-within .vip-inst-subnav__menu {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/VipInstitutionalSubnav/vip-institutional-subnav.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":[".vip-inst-subnav {\n  background: #0b0e11;\n  border-bottom: 1px solid rgba(243, 186, 47, 0.18);\n  position: relative;\n  z-index: 30;\n}\n\nbody.light_theme .vip-inst-subnav {\n  background: #111318;\n}\n\n.vip-inst-subnav__inner {\n  width: 1480px;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-height: 56px;\n  overflow: visible;\n}\n\n.vip-inst-subnav__brand {\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #fff;\n  text-decoration: none;\n  margin-right: 18px;\n  white-space: nowrap;\n}\n\n.vip-inst-subnav__brand span {\n  color: #f3ba2f;\n}\n\n.vip-inst-subnav__item {\n  position: relative;\n}\n\n.vip-inst-subnav__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  padding: 16px 14px;\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.72);\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n}\n\n.vip-inst-subnav__link:hover,\n.vip-inst-subnav__link.is-active {\n  color: #f3ba2f;\n  text-decoration: none;\n}\n\n.vip-inst-subnav__link.is-active {\n  border-bottom-color: #f3ba2f;\n}\n\n.vip-inst-subnav__caret {\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 5px solid currentColor;\n  opacity: 0.7;\n}\n\n.vip-inst-subnav__menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  min-width: 360px;\n  margin: 0;\n  padding: 10px 0;\n  list-style: none;\n  background: #1e2329;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);\n  z-index: 40;\n}\n\n.vip-inst-subnav__menu-link {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  color: #eaecef;\n  text-decoration: none;\n}\n\n.vip-inst-subnav__menu-link:hover {\n  background: rgba(255, 255, 255, 0.06);\n  color: #fff;\n  text-decoration: none;\n}\n\n.vip-inst-subnav__menu-link img {\n  width: 28px;\n  height: 28px;\n  object-fit: contain;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.vip-inst-subnav__menu-title,\n.vip-inst-subnav__menu-desc {\n  display: block;\n}\n\n.vip-inst-subnav__menu-title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.vip-inst-subnav__menu-desc {\n  margin-top: 4px;\n  font-size: 12px;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.55);\n  white-space: normal;\n  max-width: 280px;\n}\n\n.vip-inst-subnav__badge,\n.nav-title-badge--new,\n.navigation .navbar-nav .dropdown-menu .dropdown-item .dropdown-item-content sub.nav-title-badge--new,\n.navbar-expand-lg .navbar-nav .dropdown-menu .dropdown-item .dropdown-item-content sub.nav-title-badge--new {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  background: #fcd535;\n  color: #181a20;\n  border-radius: 10px;\n  padding: 3px 6px;\n  position: relative;\n  bottom: 6px;\n}\n\n.dropdown-item-content .nav-title-badge--new {\n  margin-left: 6px;\n  vertical-align: middle;\n  bottom: 0;\n}\n\n.navigation .navbar-nav .dropdown-menu.dropdown-menu--institutional,\n.navbar-expand-lg .navbar-nav .dropdown-menu.dropdown-menu--institutional {\n  min-width: 440px;\n  overflow: visible;\n}\n\n.navigation .navbar-nav .dropdown-menu.dropdown-menu--institutional .dropdown-item .dropdown-item-desc,\n.navbar-expand-lg .navbar-nav .dropdown-menu.dropdown-menu--institutional .dropdown-item .dropdown-item-desc {\n  white-space: normal;\n  overflow: visible;\n  text-overflow: unset;\n}\n\n.dropdown-menu--institutional .inst-menu-arrow {\n  margin-left: 8px;\n  color: #d1aa67;\n}\n\n.dropdown-menu--institutional .inst-menu-has-children {\n  position: relative;\n}\n\n.dropdown-menu--institutional .inst-menu-flyout {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 100%;\n  min-width: 280px;\n  margin: 0;\n  padding: 8px 0;\n  list-style: none;\n  background: #1e2329;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);\n  z-index: 50;\n}\n\n.dropdown-menu--institutional .inst-menu-has-children:hover .inst-menu-flyout,\n.dropdown-menu--institutional .inst-menu-has-children:focus-within .inst-menu-flyout {\n  display: block;\n}\n\nbody.light_theme .dropdown-menu--institutional .inst-menu-flyout {\n  background: #ffffff;\n  border-color: #e2e8f0;\n}\n\n.vip-otc-nav--menu {\n  position: relative;\n}\n\n.vip-otc-nav--menu .vip-inst-subnav__menu {\n  display: none;\n}\n\n.vip-otc-nav--menu:hover .vip-inst-subnav__menu,\n.vip-otc-nav--menu:focus-within .vip-inst-subnav__menu {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
